export const getFlexiStatusColor = (status: string, withBorder = false): string => {
  switch (status) {
    case 'approved':
      return `bg-green-100 text-green-800${withBorder ? ' border border-green-200' : ''}`;
    case 'rejected':
      return `bg-red-100 text-red-800${withBorder ? ' border border-red-200' : ''}`;
    default:
      return `bg-yellow-100 text-yellow-800${withBorder ? ' border border-yellow-200' : ''}`;
  }
};
